import { useEffect } from 'react';

import { DigitalRetailing } from '../../vanillaComponent/DigitalRetailing';

function DigitalRetailingWidget() {
  useEffect(() => {
    const openIframeContainer = document.getElementById('open-iframe');

    if (openIframeContainer && !openIframeContainer.querySelector('#open-slider-button')) {
      const widgetData = {
        // containerSelector: 'open-iframe',
        // buttonName: 'Free Trade-In Estimate',
        token: 'MGxNZUFGNUp6RnVxYldOSE9acjRHbDZR', //'Z1BJRUZuS2U0dUl6UnNua2FMSGw4OGdm',
        // iframeUrl: iframeUrl,
        type: 'button',
        version: '1.0',
        // customClassName: 'custom-class-name',
        module: 'digital-retailing', // 'credit-score',
      };

      new DigitalRetailing(widgetData).render(openIframeContainer);
    }

    // If you need to clean up or perform actions when the component is unmounted,
    // you can return a cleanup function from the useEffect.
    return () => {
      // Cleanup logic (if needed)
    };
  }, []); // Empty dependency array means this effect runs only once
  // KNDPUCAF3P7085487 , WBY13HD09SFU38826
  return (
    <>
      <div
        style={{
          position: 'absolute',
          top: '60%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        <p>VIN: KNDPUCAF3P7085487</p>
        <div id='open-iframe'></div>
      </div>
    </>
  );
}

export default DigitalRetailingWidget;
